export enum ManagementOverviewActionType {

  // Load
  LoadEmployeeDiscomfortLevel                     = 'LOAD_EMPLOYEE_DISCOMFORT_LEVEL',
  LoadEmployeeDiscomfortLevelCompleted            = 'LOAD_EMPLOYEE_DISCOMFORT_LEVEL_COMPLETED',
  LoadEmployeeDiscomfortLevelFailed               = 'LOAD_EMPLOYEE_DISCOMFORT_LEVEL_FAILED',

  LoadEmployeeDiscomfortLevelDetails              = 'LOAD_EMPLOYEE_DISCOMFORT_LEVEL_DETAILS',
  LoadEmployeeDiscomfortLevelDetailsCompleted     = 'LOAD_EMPLOYEE_DISCOMFORT_LEVEL_DETAILS_COMPLETED',
  LoadEmployeeDiscomfortLevelDetailsFailed        = 'LOAD_EMPLOYEE_DISCOMFORT_LEVEL_DETAILS_FAILED',

  LoadEmployeeRiskLevel                           = 'LOAD_EMPLOYEE_RISK_LEVEL',
  LoadEmployeeRiskLevelCompleted                  = 'LOAD_EMPLOYEE_RISK_LEVEL_COMPLETED',
  LoadEmployeeRiskLevelFailed                     = 'LOAD_EMPLOYEE_RISK_LEVEL_FAILED',

  LoadEmployeeRiskLevelDetails                    = 'LOAD_EMPLOYEE_RISK_LEVEL_DETAILS',
  LoadEmployeeRiskLevelDetailsCompleted           = 'LOAD_EMPLOYEE_RISK_LEVEL_DETAILS_COMPLETED',
  LoadEmployeeRiskLevelDetailsFailed              = 'LOAD_EMPLOYEE_RISK_LEVEL_DETAILS_FAILED',

  LoadTopTenDiscomfort                            = 'LOAD_TOP_TEN_DISCOMFORT',
  LoadTopTenDiscomfortCompleted                   = 'LOAD_TOP_TEN_DISCOMFORT_COMPLETED',
  LoadTopTenDiscomfortFailed                      = 'LOAD_TOP_TEN_DISCOMFORT_FAILED',

  LoadTopTenDiscomfortDetails                     = 'LOAD_TOP_TEN_DISCOMFORT_DETAILS',
  LoadTopTenDiscomfortDetailsCompleted            = 'LOAD_TOP_TEN_DISCOMFORT_DETAILS_COMPLETED',
  LoadTopTenDiscomfortDetailsFailed               = 'LOAD_TOP_TEN_DISCOMFORT_DETAILS_FAILED',

  LoadDiscomfortLevelTrend                        = 'LOAD_DISCOMFORT_LEVEL_TREND',
  LoadDiscomfortLevelTrendCompleted               = 'LOAD_DISCOMFORT_LEVEL_TREND_COMPLETED',
  LoadDiscomfortLevelTrendFailed                  = 'LOAD_DISCOMFORT_LEVEL_TREND_FAILED',

  LoadDiscomfortLevelTrendDetails                 = 'LOAD_DISCOMFORT_LEVEL_TREND_DETAILS',
  LoadDiscomfortLevelTrendDetailsCompleted        = 'LOAD_DISCOMFORT_LEVEL_TREND_DETAILS_COMPLETED',
  LoadDiscomfortLevelTrendDetailsFailed           = 'LOAD_DISCOMFORT_LEVEL_TREND_DETAILS_FAILED',

  LoadRiskLevelTrend                              = 'LOAD_RISK_LEVEL_TREND',
  LoadRiskLevelTrendCompleted                     = 'LOAD_RISK_LEVEL_TREND_COMPLETED',
  LoadRiskLevelTrendFailed                        = 'LOAD_RISK_LEVEL_TREND_FAILED',

  LoadRiskLevelTrendDetails                       = 'LOAD_RISK_LEVEL_TREND_DETAILS',
  LoadRiskLevelTrendDetailsCompleted              = 'LOAD_RISK_LEVEL_TREND_DETAILS_COMPLETED',
  LoadRiskLevelTrendDetailsFailed                 = 'LOAD_RISK_LEVEL_TREND_DETAILS_FAILED',

  LoadPosturalRisk                                = 'LOAD_POSTURAL_RISK',
  LoadPosturalRiskCompleted                       = 'LOAD_POSTURAL_RISK_COMPLETED',
  LoadPosturalRiskFailed                          = 'LOAD_POSTURAL_RISK_FAILED',

  LoadPosturalRiskDetails                         = 'LOAD_POSTURAL_RISK_DETAILS',
  LoadPosturalRiskDetailsCompleted                = 'LOAD_POSTURAL_RISK_DETAILS_COMPLETED',
  LoadPosturalRiskDetailsFailed                   = 'LOAD_POSTURAL_RISK_DETAILS_FAILED',

  LoadProgramBenefits                             = 'LOAD_PROGRAM_BENEFITS',
  LoadProgramBenefitsCompleted                    = 'LOAD_PROGRAM_BENEFITS_COMPLETED',
  LoadProgramBenefitsFailed                       = 'LOAD_PROGRAM_BENEFITS_FAILED',

  // Reset
  ResetManagementOverview                         = 'RESET_MANAGEMENT_OVERVIEW',
}
